export const getCategoryName = (signatureId, globalCategories) => {
  let categoryName;
  Object.entries(globalCategories).forEach(([category, ids]) => {
    if (ids.includes(signatureId)) {
      categoryName = category;
    }
  });
  return categoryName;
};
